import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";

import { RouteConstants } from "../../constants";
import {
  ROUTE_PRIVACY_POLICY,
  ROUTE_TERMS_OF_USE,
  ROUTE_IMPRESSUM,
  ROUTE_DOWNLOAD,
} from "constants/route";

const Layout = lazy(() => import("components/layout"));
const HomePage = lazy(() => import("pages/home"));
const AboutUsPage = lazy(() => import("pages/about-us"));
const FaqPage = lazy(() => import("pages/faq-page"));
const CreditCardPage = lazy(() => import("pages/credit-card"));
const CreditCardRequestFormPage = lazy(() => import("pages/credit-card/form"));
const CreditRequestBasicPage = lazy(() => import("pages/credit-request/basic"));
const CreditRequestDocumentationPage = lazy(() => import("pages/credit-request/documentation"));
const CreditRequestExistsPage = lazy(() => import("pages/credit-request/exists"));
const CreditRequestFormPage = lazy(() => import("pages/credit-request/form/request"));
const CreditRequestLayout = lazy(() => import("pages/credit-request/layout"));
const CreditRequestOverviewPage = lazy(() => import("pages/credit-request/form/overview"));
const CreditRequestVerifyPage = lazy(() => import("pages/public/credit"));
const CardRequestVerifyPage = lazy(() => import("pages/public/card"));
const MobileAppPage = lazy(() => import("pages/mobile-app"));
const PrivacyPolicyPage = lazy(() => import("pages/privacy-and-policy"));
const TermsPage = lazy(() => import("pages/terms-of-use"));
const ImpressumPage = lazy(() => import("pages/impressum"));
const DownloadPage = lazy(() => import("pages/download"));
const Error404Page = lazy(() => import("pages/error/404"));
const Error406Page = lazy(() => import("pages/error/406"));
const Error500Page = lazy(() => import("pages/error/500"));
const Error503Page = lazy(() => import("pages/error/503"));

const {
  ROUTE_ABOUT_US,
  ROUTE_CREDIT_CARD,
  ROUTE_CREDIT_CARD_FORM,
  ROUTE_CREDIT_CARD_REQUEST_VERIFY,
  ROUTE_CREDIT_REQUEST,
  ROUTE_CREDIT_REQUEST_BASIC_SHORT,
  ROUTE_CREDIT_REQUEST_FORM_SHORT,
  ROUTE_CREDIT_REQUEST_EXISTS_SHORT,
  ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT,
  ROUTE_CREDIT_REQUEST_OVERVIEW,
  ROUTE_CREDIT_REQUEST_VERIFY,
  ROUTE_ERROR_406,
  ROUTE_ERROR_500,
  ROUTE_ERROR_503,
  ROUTE_FAQ,
  ROUTE_HOME,
  ROUTE_MOBILE_APP,
} = RouteConstants;

const CustomRouter = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route element={<Layout />}>
          <Route path={ROUTE_HOME} element={
            <Suspense fallback={<div>Loading...</div>}>
              <HomePage />
            </Suspense>
          } />
          <Route path={ROUTE_ABOUT_US} element={
            <Suspense fallback={<div>Loading...</div>}>
              <AboutUsPage />
            </Suspense>
          } />
          <Route path={ROUTE_FAQ} element={
            <Suspense fallback={<div>Loading...</div>}>
              <FaqPage />
            </Suspense>
          } />
          <Route path={ROUTE_CREDIT_CARD} element={
            <Suspense fallback={<div>Loading...</div>}>
              <CreditCardPage />
            </Suspense>
          } />
          <Route path={ROUTE_CREDIT_CARD_FORM} element={
            <Suspense fallback={<div>Loading...</div>}>
              <CreditCardRequestFormPage />
            </Suspense>
          } />
          <Route path={ROUTE_MOBILE_APP} element={
            <Suspense fallback={<div>Loading...</div>}>
              <MobileAppPage />
            </Suspense>
          } />
          <Route path={ROUTE_PRIVACY_POLICY} element={
            <Suspense fallback={<div>Loading...</div>}>
              <PrivacyPolicyPage />
            </Suspense>
          } />
          <Route path={ROUTE_TERMS_OF_USE} element={
            <Suspense fallback={<div>Loading...</div>}>
              <TermsPage />
            </Suspense>
          } />
          <Route path={ROUTE_IMPRESSUM} element={
            <Suspense fallback={<div>Loading...</div>}>
              <ImpressumPage />
            </Suspense>
          } />
          <Route
            path={ROUTE_CREDIT_REQUEST}
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <CreditRequestLayout />
              </Suspense>
            }
          >
            <Route
              path={ROUTE_CREDIT_REQUEST_BASIC_SHORT}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <CreditRequestBasicPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTE_CREDIT_REQUEST_FORM_SHORT}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <CreditRequestFormPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTE_CREDIT_REQUEST_EXISTS_SHORT}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <CreditRequestExistsPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <CreditRequestDocumentationPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTE_CREDIT_REQUEST_OVERVIEW}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <CreditRequestOverviewPage />
                </Suspense>
              }
            />
            <Route
              path={ROUTE_CREDIT_REQUEST + "/:id"}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <CreditRequestOverviewPage />
                </Suspense>
              }
            />
          </Route>
          <Route path={`${ROUTE_CREDIT_REQUEST_VERIFY}/:id`} element={
            <Suspense fallback={<div>Loading...</div>}>
              <CreditRequestVerifyPage />
            </Suspense>
          } />
          <Route path={`${ROUTE_CREDIT_CARD_REQUEST_VERIFY}/:id`} element={
            <Suspense fallback={<div>Loading...</div>}>
              <CardRequestVerifyPage />
            </Suspense>
          } />
        </Route>
        <Route path={ROUTE_DOWNLOAD} element={
          <Suspense fallback={<div>Loading...</div>}>
            <DownloadPage />
          </Suspense>
        } />
        <Route path={ROUTE_ERROR_406} element={
          <Suspense fallback={<div>Loading...</div>}>
            <Error406Page />
          </Suspense>
        } />
        <Route path={ROUTE_ERROR_500} element={
          <Suspense fallback={<div>Loading...</div>}>
            <Error500Page />
          </Suspense>
        } />
        <Route path={ROUTE_ERROR_503} element={
          <Suspense fallback={<div>Loading...</div>}>
            <Error503Page />
          </Suspense>
        } />
        <Route path="*" element={
          <Suspense fallback={<div>Loading...</div>}>
            <Error404Page />
          </Suspense>
        } />
      </Routes>
    </Suspense>
  );
};

export default CustomRouter;
